module.exports = __webpack_public_path__ + "media/assets/images/account-circle-outline-fcc2589daa8cc9c1a7aed41e93e5630c.svg";